module.exports = __webpack_public_path__ + "media/assets/bronzeFooter-f0cce5cbff6b5323c26080400d8508d7.png";